export const SENTRY_RELEASE = "1.3.3";
export const APP_VERSION = "1.3.3";
